export const FETCH_ALLUSER = 'views/users/FETCH_ALLUSER'
export const FETCH_PAGES = 'views/users/FETCH_PAGES'
export const FETCH_USER_PERMISSION = 'views/users/FETCH_USER_PERMISSION'
export const FETCH_PERMISSIONS = 'views/users/FETCH_PERMISSIONS'
export const FETCH_ROLES = 'views/users/FETCH_ROLES'
export const FETCH_ALLROLL = 'views/users/FETCH_ALLROLL'



